export interface AssetType {
  id: number;
  name: string | null;
}

export enum AssetTypeEnum {
  Truck = 1,
  Trailer = 2,
}
